import ConfigService from '../index'
class TipoEspacoService extends ConfigService {
    constructor(){
        super('agendalabs/api/v1/tipo_espaco/')
    }
}
export default TipoEspacoService
